export default _ =>{ 
  const match = /#\/(.*)\//.exec(window.location.hash) 
  return match ? match[1] : "fr"
}



/** WEBPACK FOOTER **
 ** ./app/utils/getLocaleFromUrl.js
 **/